import { updateField } from 'vuex-map-fields';
import { getFormData } from './types';

export default {
    clearForm(state) {
        state.formData = getFormData(); 
    },
    setLoadingFetch(state, loadingFetch) {
        state.loadingFetch = loadingFetch; 
    },
    setFormData(state, formData) {
        state.formData = formData;
    },
    setBuyer(state, buyer) {
        state.formData.buyer = buyer;
    },
    setBuyerAdress(state, address) {
        state.formData.buyer.address = address;
    },
    setBovines(state, bovines) {
        state.formData.bovines = bovines;
    },
    setIsRedoing(state, isRedoing) {
        state.isRedoing = isRedoing;
    },
    updateField,
}
